const fontUrl = (filename) => {
  return `/a/fa/listing/static/fonts/${filename}`;
};

const svgUrl = (filename) => {
  return `/a/fa/listing/static/styles/svg/${filename}`;
};

const operatorSvgUrl = (filename) => {
  return `/a/fa/listing/static/styles/svg/ConnectFilterIcons/${filename}`;
};
export { fontUrl, operatorSvgUrl, svgUrl };
